// extracted by mini-css-extract-plugin
export default {"fontIcon":"style_fontIcon__P2kGJ","checkbox":"style_checkbox__b6H3q","buttonWrraper":"style_buttonWrraper__JhIpD"};